import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  CardTitle,
  Form,
  Label,
  Input,
  Progress,
} from "reactstrap"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import Select from "react-select"
import { Slide, toast, ToastContainer } from "react-toastify"

const DataTableMatiere = props => {
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  // Data Table
  const [orders, setOrders] = useState([])
  const [departement, setDepartement] = useState([])
  const [selectDepartement, setSelectDepartement] = useState("")
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [selectSemestre, setSelectSemestre] = useState("")

  const [edit, setEdit] = useState(0)
  const [delet, setDelet] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [cycle, setCycle] = useState([])
  const [selectCycle, setSelectCycle] = useState("")
  const [niveau, setNiveau] = useState([])
  const [selectNiveau, setSelectNiveau] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [salle, setSalle] = useState([])
  const [selectSalle, setSelectSalle] = useState("")
  const [modalUnDemi, setModalUnDemi] = useState(false)
  const [demiGroup, setDemiGroup] = useState(1)
  const [demiGroupReg, setDemiGroupReg] = useState(0)
  const [modalAdd, setModalAdd] = useState(false)
  const [add, setAdd] = useState(0)
  const [modalImport, setModalImport] = useState(false)
  const [file, setFile] = useState(null)
  const [uploadPercent, setUploadPercent] = useState(0)
  const [diplome, setDiplome] = useState([])
  const [selectDiplome, setSelectDiplome] = useState("")
  const [modalDelete, setModalDelete] = useState(false)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    sizePerPage: 30,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }

  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "id",
      text: "#Id",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "semestre",
      text: "Semestre",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "name",
      text: "Matière",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "module",
      text: "Module",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "nbr_heure_cours",
      text: "Nbh cours",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "nbr_heure_td",
      text: "Nbh TD",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "autres",
      text: "Nbh Autre",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "nbr_heure_tp",
      text: "Nbh TP",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "Affecté une salle spécifique",
      isDummyField: true,
      text: "Affecté une salle spécifique",
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          add === 1 ? (
            row.salle_name === 0 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  style={{
                    color: "#A30C9370",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                  onClick={() => toggleAdd(row.id)}
                  className="fas fa-door-open"
                  title="Affecté une salle spécifique"
                ></i>
              </div>
            ) : (
              <p
                title="Effectuez un double-clic pour modifier la salle"
                onDoubleClick={() => toggleAdd(row.id)}
              >
                {row.salle_name}
              </p>
            )
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{
                  color: "#A7A3A3",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                className="fas fa-door-open"
                title="Vouz n'avez pas d'accées"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer", fontSize: "15px" }}
              className="fas fa-door-open"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Un demi groupe",
      isDummyField: true,
      text: "Un demi groupe",
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          add === 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{
                  color: "#5E065270",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                onClick={() => toggleUnDemi(row.id)}
                className="fas fa-users"
                title="Affecté une salle spécifique"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{
                  color: "#A7A3A3",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                className="fas fa-users"
                title="Vouz n'avez pas d'accées"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer", fontSize: "15px" }}
              className="fas fa-users"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Action",
      isDummyField: true,
      text: "Action",
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "space-evenly" }}>
          {/* === EDIT === */}
          {cloture !== 1 ? (
            edit === 1 ? (
              <Link to={"/EditMatiere?id=" + row.id}>
                <i
                  style={{
                    color: "cornflowerblue",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                  className="fas fa-edit"
                  title={"Modifier cette matière"}
                ></i>
              </Link>
            ) : (
              <i
                style={{
                  color: "#a7a3a3",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                className="fas fa-edit"
                title="Vous n'avez pas d'accès"
              ></i>
            )
          ) : (
            <i
              style={{ color: "#a7a3a3", cursor: "pointer", fontSize: "15px" }}
              className="fas fa-edit"
              title="Année clôturée"
            ></i>
          )}

          {/* === DELETE === */}
          {cloture !== 1 ? (
            delet === 1 ? (
              row.etat !== 0 ? (
                <i
                  style={{
                    color: "#ED6464",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                  onClick={() => toggle(row.id)}
                  className="fas fa-trash-alt"
                  title={"Supprimer cette matière ?"}
                ></i>
              ) : (
                <i
                  style={{
                    color: "#A7A3A3",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                  className="fas fa-trash-alt"
                  title="Cette matière est déjà utilisée"
                ></i>
              )
            ) : (
              <i
                style={{
                  color: "#A7A3A3",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
                className="fas fa-trash-alt"
                title="Vous n'avez pas d'accès"
              ></i>
            )
          ) : (
            <i
              style={{ color: "#A7A3A3", cursor: "pointer", fontSize: "15px" }}
              className="fas fa-trash-alt"
              title="Année clôturée"
            ></i>
          )}
        </div>
      ),
    },
    // {
    //     dataField: "Modification",
    //     isDummyField: true,
    //     text: "Modification",
    //     style: {textAlign: "center"},
    //     headerStyle: (colum, colIndex) => {
    //         return {textAlign: "center"}
    //     },
    //     sort: true,
    //     // eslint-disable-next-line react/display-name
    //     formatter: (cellContent, row) => (
    //         cloture != 1 ? (
    //             edit === 1 ? (
    //                 <div style={{display: "flex", justifyContent: "center"}}>
    //                     <Link to={"/EditMatiere?id=" + row.id}>
    //                         <i
    //                             style={{color: "cornflowerblue", cursor: "pointer"}}
    //                             className="fas fa-edit"
    //                         ></i>
    //                     </Link>
    //                 </div>
    //             ) : (
    //                 <div style={{display: "flex", justifyContent: "center"}}>
    //                     <i
    //                         style={{color: "#a7a3a3", cursor: "pointer"}}
    //                         className="fas fa-edit"
    //                     ></i>
    //                 </div>
    //             )
    //         ) : (
    //             <div style={{display: "flex", justifyContent: "center"}}>
    //                 <i
    //                     style={{color: "#a7a3a3", cursor: "pointer"}}
    //                     className="fas fa-edit"
    //                     title="Année clôturée"
    //                 ></i>
    //             </div>
    //         )
    //     ),
    // },
    // {
    //     dataField: "Suppression",
    //     isDummyField: true,
    //     text: "Suppression",
    //     style: {textAlign: "center"},
    //     headerStyle: (colum, colIndex) => {
    //         return {textAlign: "center"}
    //     },
    //     sort: true,
    //     // eslint-disable-next-line react/display-name
    //     formatter: (cellContent, row) =>
    //         cloture != 1 ? (
    //             delet === 1 ? (
    //                 row.etat != 0 ? (
    //                     <div style={{display: "flex", justifyContent: "center"}}>
    //                         <i
    //                             style={{color: "#ED6464", cursor: "pointer"}}
    //                             onClick={() => toggle(row.id)}
    //                             className="fas fa-trash-alt"
    //                         ></i>
    //                     </div>
    //                 ) : (
    //                     <div style={{display: "flex", justifyContent: "center"}}>
    //                         <i
    //                             style={{color: "#A7A3A3", cursor: "pointer"}}
    //                             className="fas fa-trash-alt"
    //                             title="Cette matiere déja utilisé"
    //                         ></i>
    //                     </div>
    //                 )
    //             ) : (
    //                 <div style={{display: "flex", justifyContent: "center"}}>
    //                     <i
    //                         style={{color: "#A7A3A3", cursor: "pointer"}}
    //                         className="fas fa-trash-alt"
    //                         title="Vouz n'avez pas d'accées"
    //                     ></i>
    //                 </div>
    //             )
    //         ) : (
    //             <div style={{display: "flex", justifyContent: "center"}}>
    //                 <i
    //                     style={{color: "#A7A3A3", cursor: "pointer"}}
    //                     className="fas fa-trash-alt"
    //                     title="Année clôturée"
    //                 ></i>
    //             </div>
    //         )
    // },
  ]

  const { SearchBar } = Search
  const toggleAdd = id => {
    setModalAdd(!modalAdd)
    setId(id)
    API.get("salle/select").then(resSalle => {
      setSalle(resSalle.data.Salle)
    })
  }
  const toggleUnDemi = id => {
    setModalUnDemi(!modalUnDemi)
    setId(id)
    setDemiGroup(1)
  }
  const toggleAddSalle = async () => {
    setLoading(false)
    const res = await API.post("matiere/getsalle", {
      matiere_id: id,
      salle_id: selectSalle,
      user_id,
      annee_id,
    }).then(res => {
      setModalAdd(false)
      const resD = API.post("matiere/list", { annee_id }).then(resD => {
        setOrders(resD.data.Matiere)
        setLoading(true)
      })
    })
  }
  const toggleAddAnnuler = async () => {
    setLoading(false)
    const res = await API.post("matiere/annuler_affectation_salle_matiere", {
      matiere_id: id,
      user_id,
      annee_id,
    }).then(res => {
      setModalAdd(false)
      const resD = API.post("matiere/list", { annee_id }).then(resD => {
        setOrders(resD.data.Matiere)
        setLoading(true)
      })
    })
  }
  const toggleUnDemiGroup = async () => {
    setLoading(false)
    const res = await API.post("matiere/update_option", {
      matiere_id: id,
      option: demiGroup,
      assembler: demiGroupReg,
      user_id,
      annee_id,
    }).then(res => {
      setModalUnDemi(false)
      const resD = API.post("matiere/list", { annee_id }).then(resD => {
        setOrders(resD.data.Matiere)
        setLoading(true)
      })
    })
  }
  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Matière")
    )
    setAdd(typeArticleSubMenu.sous_menu[2].add)
    setEdit(typeArticleSubMenu.sous_menu[2].edit)
    setDelet(typeArticleSubMenu.sous_menu[2].delete)
    //niveau
    const resNiveau = await API.get("niveau/select").then(resNiveau => {
      setNiveau(resNiveau.data.Niveau)
    })
    const resDepartement = await API.get("departement/select").then(
      resDepartement => {
        setDepartement(resDepartement.data.Departement)
        setSelectDepartement("")
      }
    )
    const res = await API.post("matiere/list", { annee_id }).then(res => {
      setOrders(res.data.Matiere)
    })
    const resC = await API.get("cycle/select").then(resC => {
      setCycle(resC.data.Cycle)
    })
    const resDiplome = await API.post("diplome/select", { annee_id }).then(
      resDiplome => {
        setDiplome(resDiplome.data.Diplome)
      }
    )
    setLoading(true)
  }, [])

  const toggleImport = id => {
    setModalImport(!modalImport)
  }
  const toggleDeleteMat = id => {
    if (!selectSpecialite) {
      toast.error("Voulez-vous choisir une spécialité !", {
        containerId: "A",
      })
      return
    }

    if (!selectDepartement) {
      toast.error("Voulez-vous choisir un département !", {
        containerId: "A",
      })
      return
    }

    if (!selectNiveau) {
      toast.error("Voulez-vous choisir un niveau !", {
        containerId: "A",
      })
      return
    }

    if (!selectSemestre) {
      toast.error("Voulez-vous choisir un semestre !", {
        containerId: "A",
      })
      return
    }

    setModalDelete(!modalDelete)
  }
  const toggle = id => {
    setModal(!modal)
    setId(id)
  }

  const toggleDelete = async () => {
    const res = await API.post("matiere/delete", {
      id: id,
      user_id,
      annee_id,
    }).then(res => {
      setModal(false)
      const resD = API.post("matiere/list", { annee_id }).then(resD => {
        setOrders(resD.data.Matiere)
      })
      setLoading(true)
    })
  }
  const toggleDeleteMatiere = async () => {
    if (!selectSpecialite) {
      toast.error("Voulez-vous choisir une spécialité !", {
        containerId: "A",
      })
      return
    }

    if (!selectDepartement) {
      toast.error("Voulez-vous choisir un département !", {
        containerId: "A",
      })
      return
    }

    if (!selectNiveau) {
      toast.error("Voulez-vous choisir un niveau !", {
        containerId: "A",
      })
      return
    }

    if (!selectSemestre) {
      toast.error("Voulez-vous choisir un semestre !", {
        containerId: "A",
      })
      return
    }

    try {
      setLoading(true)

      const res = await API.post("matiere/delete_matieres", {
        specialite_id: selectSpecialite.value,
        departement_id: selectDepartement.value,
        niveau_id: selectNiveau.value,
        semestre_id: selectSemestre.value,
        user_id,
        annee_id,
      })

      // Récupérer les informations retournées par l'API
      const message = res.data.msg
      const matieresIds = res.data.Resultat?.matieres_ids || []

      // Afficher les IDs dans le toast
      toast.success(`${message}\nIDs supprimés : ${matieresIds.join(", ")}`, {
        containerId: "A",
        autoClose: 5000,
      })

      setModalDelete(!modalDelete)
      setSelectCycle("")
      setSelectNiveau("")
      setSelectDepartement("")
      setSelectSpecialite("")
      setSelectSemestre("")
      setSelectDiplome("")
      // Actualiser la liste
      const resD = await API.post("matiere/list", {
        annee_id,
      })

      setOrders(resD.data.Matiere)
    } catch (error) {
      console.error(error)

      toast.error(
        error.response?.data?.msg ||
          "Une erreur est survenue lors de la suppression.",
        {
          containerId: "A",
        }
      )
    } finally {
      setLoading(true)
    }
  }

  useEffect(() => {
    setModal(false)
  }, [orders])
  const search = async () => {
    const specialite_id =
      selectSpecialite != "" && selectSpecialite != null
        ? selectSpecialite.value
        : 0
    const departement_id =
      selectDepartement != "" && selectDepartement != null
        ? selectDepartement.value
        : 0
    const semestre_id =
      selectSemestre != "" && selectSemestre != null ? selectSemestre.value : 0
    const niveau_id =
      selectNiveau != "" && selectNiveau != null ? selectNiveau.value : 0

    setOrders([])
    const res = await API.post("matiere/search", {
      specialite_id: specialite_id,
      departement_id: departement_id,
      semestre_id: semestre_id,
      niveau_id: niveau_id,
      annee_id,
    }).then(res => {
      setOrders(res.data.Matiere)
    })
  }
  const searchAll = async () => {
    setSelectCycle("")
    setSelectNiveau("")
    setSelectDepartement("")
    setSelectSpecialite("")
    setSelectSemestre("")
    const res = await API.post("matiere/list", { annee_id }).then(res => {
      setOrders(res.data.Matiere)
    })
  }
  const getNiveau = async event => {
    var cycle_id = event.value
    setSelectCycle(event)
    setSelectNiveau("")
    setSelectSpecialite("")
    if (cycle_id == 1) {
      const res = await API.get("niveau/select").then(res => {
        setNiveau(res.data.Niveau)
      })
    } else {
      const res = await API.get("niveau/select_mastere").then(res => {
        setNiveau(res.data.Niveau)
      })
    }
  }

  const getSpec = async event => {
    var departement_id = event.value
    setSelectSpecialite("")
    setSelectDepartement(event)
    const res = await API.post("specialite/select_by_departement_cycle", {
      departement_id: departement_id,
      cycle_id: selectCycle.value,
      annee_id,
    }).then(res => {
      setSpecialite(res.data.Specialite)
    })
  }
  const getDiplome = async event => {
    setSelectSpecialite(event)
    setSelectDiplome("")
    const res = await API.post("diplome/get_by_cyc_niv_spec_sem", {
      annee_id,
      specialite_id: event.value,
      departement_id: selectDepartement.value,
      cycle_id: selectCycle.value,
    }).then(res => {
      setDiplome(res.data.Diplomes)
    })
  }

  const addFile = e => {
    var file = e.target.files[0]
    setFile(file)
  }
  const uploadFile = async () => {
    var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
    )
    var annee_id = userAuthScolarite.user.annee_id
    if (selectDepartement == "") {
      toast.error("Voulez-vous choisir un département !", {
        containerId: "A",
      })
    } else if (selectDiplome == "") {
      toast.error("Voulez-vous choisir un diplôme !", {
        containerId: "A",
      })
    } else if (selectNiveau == "") {
      toast.error("Voulez-vous choisir un niveau !", {
        containerId: "A",
      })
    } else if (selectCycle !== "") {
      let data = new FormData()
      data.append("file", file)
      data.append("departement_id", selectDepartement.value)
      data.append("diplome_id", selectDiplome.value)
      data.append("niveau_id", selectNiveau.value)
      data.append("cycle_id", selectCycle.value)
      data.append("annee_id", annee_id)
      data.append("user_id", user_id)
      const options = {
        onUploadProgress: progressEvent => {
          const { loaded, total } = progressEvent
          let percent = Math.round((loaded * 100) / total)
          console.log(`${loaded}kb of ${total}kb | ${percent}%`)
          if (percent < 100) {
            setUploadPercent(percent)
          }
        },
      }
      API.post("plan_etude/import_matieres", data, options).then(res => {
        setUploadPercent(100)
        API.post("matiere/list", {
          annee_id: annee_id,
        }).then(res => {
          setModalImport(!modalImport)
          setOrders(res.data.Matiere)
        })
      })
    } else {
      toast.error("Voulez-vous choisir un cycle !", {
        containerId: "A",
      })
    }
  }
  return (
    <React.Fragment>
      <div>
        <Row>
          <Col xs="12">
            <ToolkitProvider
              keyField="id"
              data={orders}
              columns={Columns()}
              search
              bootstrap4
            >
              {toolkitProps => (
                <>
                  <CardTitle style={{ color: "#556ee6" }} className="h4">
                    Critéres de Recherches
                  </CardTitle>

                  <Form className="mt-4">
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label>Cycle :</Label>
                          <Select
                            options={cycle}
                            isSearchable
                            value={selectCycle}
                            onChange={e => getNiveau(e)}
                          />
                        </div>
                      </Col>

                      <Col lg="6">
                        <div className="mb-3">
                          <Label>Niveau :</Label>
                          <Select
                            options={niveau}
                            isSearchable
                            value={selectNiveau}
                            onChange={e => setSelectNiveau(e)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label>Département :</Label>
                          <Select
                            options={departement}
                            isSearchable
                            value={selectDepartement}
                            onChange={e => getSpec(e)}
                          />
                        </div>
                      </Col>

                      <Col lg="6">
                        <div className="mb-3">
                          <Label>Spécialité :</Label>
                          <Select
                            options={specialite}
                            isSearchable
                            value={selectSpecialite}
                            onChange={e => getDiplome(e)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label>Semestre :</Label>
                          <Select
                            options={semestre}
                            isSearchable
                            value={selectSemestre}
                            onChange={e => setSelectSemestre(e)}
                          />
                        </div>
                      </Col>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label>Diplôme :</Label>
                          <Select
                            options={diplome}
                            isSearchable
                            value={selectDiplome}
                            onChange={e => setSelectDiplome(e)}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Form>

                  <Row className="mb-4 text-center">
                    <Col lg="12">
                      <button
                        type="button"
                        className="btn btn-success mb-2 me-2"
                        style={{
                          backgroundColor: "#761C19",
                          borderColor: "#761C19",
                        }}
                        onClick={search}
                      >
                        Rechercher
                      </button>
                      <button
                        type="button"
                        className="btn btn-success mb-2 me-2"
                        style={{
                          backgroundColor: "#761C19",
                          borderColor: "#761C19",
                        }}
                        onClick={searchAll}
                      >
                        Afficher tout
                      </button>
                      {cloture != 1 ? (
                        <Button
                          type="button"
                          color="success"
                          className="btn  mb-2 me-2"
                          onClick={toggleImport}
                        >
                          <i className="fas fa-file-import me-1" />
                          Import les nouvelles matières
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          color="success"
                          className="btn  mb-2 me-2"
                          disabled={true}
                        >
                          <i className="fas fa-file-import me-1" />
                          Import les nouvelles matières
                        </Button>
                      )}
                      {cloture != 1 ? (
                        <Button
                          type="button"
                          color="danger"
                          className="btn  mb-2 me-2"
                          onClick={toggleDeleteMat}
                        >
                          <i className="fas fa-trash me-1" />
                          Supprimer les matières
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          color="danger"
                          className="btn  mb-2 me-2"
                          disabled={true}
                        >
                          <i className="fas fa-trash me-1" />
                          Supprimer les matières
                        </Button>
                      )}
                    </Col>
                  </Row>

                  {/* TABLE / LOADING */}
                  {loading ? (
                    <>
                      <Row>
                        <Col sm="4">
                          <div className="search-box me-2 mb-2 d-inline-block">
                            <div className="position-relative">
                              <SearchBar {...toolkitProps.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        noDataIndication={() => <NoDataIndication />}
                        striped={false}
                        bordered={false}
                        classes="table align-middle table-nowrap"
                        headerWrapperClasses="table-light"
                        rowStyle={row =>
                          row.optionnel === 1
                            ? { backgroundColor: "#faefe4" }
                            : {}
                        }
                        hover
                        pagination={paginationFactory(pageOptions)}
                        {...toolkitProps.baseProps}
                      />
                    </>
                  ) : (
                    <div className="text-center my-4">
                      <Spinner type="grow" color="primary" />
                      <h4 className="mt-3">En cours ...</h4>
                    </div>
                  )}
                </>
              )}
            </ToolkitProvider>
          </Col>
        </Row>
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {" Suppression d'une matière"}{" "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer cette Matière ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDelete}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalAdd} toggle={toggleAdd} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleAdd}
          tag="h4"
        >
          {"Affectation une salle spécifique"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">Salle:</Label>
                  <Select
                    options={salle}
                    isSearchable={true}
                    isMulti={true}
                    onChange={e => setSelectSalle(e)}
                  />
                </div>
              </Col>
            </Row>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleAddSalle}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Confirmer
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleAddAnnuler}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Annuler l'affectation de salle"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalUnDemi} toggle={toggleUnDemi} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleUnDemi}
          tag="h4"
        >
          {"Attribuer cette matière à un demi-groupe"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <Row>
              <Col
                md={12}
                style={{ marginBottom: "30px", textAlign: "center" }}
              >
                <div className="mb-12">
                  <Label className="d-block mb-3">
                    <h4>{"Sélection d’un demi-groupe"} :</h4>
                  </Label>
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      id="customRadioInline1"
                      name="customRadioInline1"
                      className="form-check-input"
                      checked={demiGroup === 1}
                      onChange={e => setDemiGroup(1)}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="customRadioInline1"
                    >
                      Oui
                    </Label>
                  </div>
                  &nbsp;
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      id="customRadioInline2"
                      name="customRadioInline1"
                      className="form-check-input"
                      checked={demiGroup === 0}
                      onChange={e => setDemiGroup(0)}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="customRadioInline2"
                    >
                      Non
                    </Label>
                  </div>
                </div>
                <hr />
                <div className="mb-12">
                  <Label className="d-block mb-3">
                    <h4>{"Choix de groupes"} :</h4>
                  </Label>
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      id="customRadioInline12"
                      name="customRadioInline12"
                      className="form-check-input"
                      checked={demiGroupReg === 1}
                      onChange={e => setDemiGroupReg(1)}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="customRadioInline12"
                    >
                      Tous les groupes
                    </Label>
                  </div>
                  &nbsp;
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      id="customRadioInline22"
                      name="customRadioInline12"
                      className="form-check-input"
                      checked={demiGroupReg === 0}
                      onChange={e => setDemiGroupReg(0)}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="customRadioInline22"
                    >
                      Un seul groupe
                    </Label>
                  </div>
                </div>
              </Col>
            </Row>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleUnDemiGroup}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Confirmer
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleUnDemi}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Annuler
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalImport} toggle={toggleImport} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "20px",
            color: "#556ee6",
          }}
          toggle={toggleImport}
        >
          Importation Liste des matières
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            {uploadPercent <= 0 ? (
              <Input
                onChange={e => addFile(e)}
                className="form-control mt-4"
                type="file"
                id="formFile"
              />
            ) : null}
            {uploadPercent > 0 && uploadPercent < 100 ? (
              <Progress
                striped
                className="progress-xl"
                color="success"
                value={uploadPercent}
              >
                {uploadPercent}%
              </Progress>
            ) : null}
            {uploadPercent == 100 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                Success
                <i
                  style={{
                    paddingLeft: "5px",
                    color: "darkcyan",
                    paddingTop: "3.5px",
                  }}
                  className="fas fa-check me-1"
                />
              </div>
            ) : null}
            {uploadPercent != 100 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="button"
                  color="success"
                  className="btn mb-2 me-2 mt-4"
                  onClick={uploadFile}
                >
                  <i className="fas fa-cloud-upload-alt me-1" />
                  Upload
                </Button>
              </div>
            ) : null}
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalDelete} toggle={toggleDeleteMat} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleDeleteMat}
          tag="h4"
        >
          {" Suppression les matières"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer ces matières ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDeleteMatiere}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleDeleteMat}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(DataTableMatiere)
DataTableMatiere.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
}
